import { Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../../../../locales/translations';
import { useMemo } from 'react';

export default function OnlineFixedFooter() {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_GRADING_STRUCTURE,
  );

  const texts = useMemo(() => {
    return {
      title: t(
        'form.partialEvaluationGradeEntry.onlineDeliveryModeAndFixedStructureFooter.title',
      ),
      subtitle: t(
        'form.partialEvaluationGradeEntry.onlineDeliveryModeAndFixedStructureFooter.subtitle',
      ),
    };
  }, [t]);
  return (
    <tr>
      <td colSpan={4}>
        <Col
          xs={12}
          className="d-flex flex-column align-items-center p-5"
          colSpan={3}
        >
          <Row>
            <Icon name="information" size="52px" color="primary" />
          </Row>
          <Row className="mt-5">
            <p className="fs-22 fw-400">{texts.title}</p>
          </Row>
          <Row>
            <p className="fs-18 fw-400">{texts.subtitle}</p>
          </Row>
        </Col>
      </td>
    </tr>
  );
}
